module.exports = __webpack_public_path__ + "img/rl-small-icon-white.db062dd8.png";